import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Heading,
  HStack,
  Image,
  Link,
  Stack,
  Text,
  useBreakpointValue,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { profileIcon } from "assets/images";
import {
  getTheme,
  setCurrnetLanguage,
  toggleTheme,
} from "features/apps/global_slice";
import { getSession, signOut } from "features/auth/slice";
import { useTranslation } from "languages";
import React from "react";
import { useNavigate } from "react-router-dom";
import { AppLinks } from "tools/navigations";
import { persistor, useAppDispatch, useAppSelector } from "tools/store";
import TouchableOpacity from "../common/TouchableOpacity";
import { setSelectedSurah } from "features/apps/non_persist_slice";

const CustomeDrawer: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const userData = useAppSelector(getSession);
  const dispatch = useAppDispatch();
  const colorMode = useAppSelector(getTheme);
  const navigation = useNavigate();
  const { translation, changeTranslation, isArabic } = useTranslation();

  const handleLogout = () => {
    persistor.purge();
    dispatch(signOut());
    window.location.href = "/";
  };

  const list = [
    ...(!userData?.user
      ? []
      : [
          {
            value: "edit_profile",
            route: AppLinks.PROFILE,
            icon: (
              <svg
                id="user-edit"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  id="vuesax_outline_user-edit"
                  data-name="vuesax/outline/user-edit"
                >
                  <g id="user-edit-2" data-name="user-edit">
                    <path
                      id="Vector"
                      d="M5.75,11.5A5.75,5.75,0,1,1,11.5,5.75,5.757,5.757,0,0,1,5.75,11.5Zm0-10A4.25,4.25,0,1,0,10,5.75,4.255,4.255,0,0,0,5.75,1.5Z"
                      transform="translate(6.25 1.25)"
                      fill="#bf8d46"
                    />
                    <path
                      id="Vector-2"
                      data-name="Vector"
                      d="M1.4,8.329a1.4,1.4,0,0,1-1-.4A1.416,1.416,0,0,1,.018,6.7l.19-1.35A2.007,2.007,0,0,1,.717,4.33L4.258.789A2.325,2.325,0,0,1,5.886,0a2.422,2.422,0,0,1,1.651.79,2.366,2.366,0,0,1,.79,1.64,2.293,2.293,0,0,1-.79,1.63L4,7.6a1.983,1.983,0,0,1-1.02.51l-1.35.19A.913.913,0,0,1,1.4,8.329ZM5.888,1.5c-.185,0-.349.128-.57.35L1.777,5.389a.39.39,0,0,0-.08.17l-.18,1.25,1.25-.18a.556.556,0,0,0,.17-.09L6.477,3c.131-.131.35-.379.35-.571a.947.947,0,0,0-.35-.58C6.233,1.6,6.057,1.5,5.888,1.5Z"
                      transform="translate(14.422 14.42)"
                      fill="#bf8d46"
                    />
                    <path
                      id="Vector-3"
                      data-name="Vector"
                      d="M2.767,3.687A3.977,3.977,0,0,1,.027.947a.747.747,0,0,1,1.44-.4,2.466,2.466,0,0,0,1.7,1.7.749.749,0,0,1-.2,1.47A.645.645,0,0,1,2.767,3.687Z"
                      transform="translate(17.953 15.502)"
                      fill="#bf8d46"
                    />
                    <path
                      id="Vector-4"
                      data-name="Vector"
                      d="M0,7.75C0,3.48,4.19,0,9.34,0a11.217,11.217,0,0,1,3.18.46.747.747,0,1,1-.43,1.43,9.677,9.677,0,0,0-2.75-.4c-4.32,0-7.84,2.8-7.84,6.25a.758.758,0,0,1-.75.76A.755.755,0,0,1,0,7.75Z"
                      transform="translate(2.66 14.25)"
                      fill="#bf8d46"
                    />
                    <path
                      id="Vector-5"
                      data-name="Vector"
                      d="M24,0V24H0V0Z"
                      fill="#bf8d46"
                      opacity="0"
                    />
                  </g>
                </g>
              </svg>
            ),
          },
          // {
          //   value: "bookmarks",
          //   route: AppLinks.BOOKMARK,
          //   icon: (
          //     <svg
          //       id="archive-minus"
          //       xmlns="http://www.w3.org/2000/svg"
          //       width="24"
          //       height="24"
          //       viewBox="0 0 24 24"
          //     >
          //       <g
          //         id="vuesax_outline_archive-minus"
          //         data-name="vuesax/outline/archive-minus"
          //       >
          //         <g id="archive-minus-2" data-name="archive-minus">
          //           <path
          //             id="Vector"
          //             d="M2.37,21.5a2.31,2.31,0,0,1-1.16-.3A2.753,2.753,0,0,1,0,18.71V4.61A4.615,4.615,0,0,1,4.61,0h9.65A4.615,4.615,0,0,1,18.87,4.61V18.7A2.751,2.751,0,0,1,17.66,21.19a2.27,2.27,0,0,1-1.162.3,3.356,3.356,0,0,1-1.608-.453l-4.88-2.71a1.436,1.436,0,0,0-1.15,0L3.98,21.04A3.373,3.373,0,0,1,2.37,21.5Zm7.07-4.787a2.728,2.728,0,0,1,1.3.307l4.881,2.71a1.83,1.83,0,0,0,.874.272.78.78,0,0,0,.406-.1,1.353,1.353,0,0,0,.47-1.2V4.61A3.113,3.113,0,0,0,14.26,1.5H4.62A3.113,3.113,0,0,0,1.51,4.61V18.7a1.33,1.33,0,0,0,.47,1.2.777.777,0,0,0,.406.1,1.83,1.83,0,0,0,.874-.272l4.88-2.71A2.732,2.732,0,0,1,9.44,16.713Z"
          //             transform="translate(2.56 1.25)"
          //             fill="#bf8d46"
          //           />
          //           <path
          //             id="Vector-2"
          //             data-name="Vector"
          //             d="M24,0V24H0V0Z"
          //             fill="#bf8d46"
          //             opacity="0"
          //           />
          //         </g>
          //       </g>
          //     </svg>
          //   ),
          // },
        ]),
    {
      value: "radio",
      route: AppLinks.RADIO,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 25 25"
        >
          <g id="external-drive" transform="translate(0.5 0.5)">
            <g
              id="vuesax_twotone_external-drive"
              data-name="vuesax/twotone/external-drive"
            >
              <g id="external-drive-2" data-name="external-drive">
                <path
                  id="Vector"
                  d="M5,20a4.724,4.724,0,0,1-5-5V5A4.724,4.724,0,0,1,5,0h7a4.724,4.724,0,0,1,5,5V15a4.724,4.724,0,0,1-5,5Z"
                  transform="translate(4 2)"
                  fill="none"
                  stroke="#bf8d46"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  stroke-dasharray="0 0"
                />
                <path
                  id="Vector-2"
                  data-name="Vector"
                  d="M0,0H17"
                  transform="translate(4 15)"
                  fill="none"
                  stroke="#bf8d46"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  stroke-dasharray="0 0"
                />
                <path
                  id="Vector-3"
                  data-name="Vector"
                  d="M0,0H1"
                  transform="translate(7 12)"
                  fill="none"
                  stroke="#bf8d46"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  stroke-dasharray="0 0"
                />
                <path
                  id="Vector-4"
                  data-name="Vector"
                  d="M0,0H1"
                  transform="translate(7 9.5)"
                  fill="none"
                  stroke="#bf8d46"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  stroke-dasharray="0 0"
                />
                <path
                  id="Vector-5"
                  data-name="Vector"
                  d="M0,0H1"
                  transform="translate(7 7)"
                  fill="none"
                  stroke="#bf8d46"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  stroke-dasharray="0 0"
                />
                <path
                  id="Vector-6"
                  data-name="Vector"
                  d="M24,0V24H0V0Z"
                  fill="none"
                  stroke="#bf8d46"
                  stroke-width="1"
                  opacity="0"
                />
                <path
                  id="Vector-7"
                  data-name="Vector"
                  d="M.495.5H.5"
                  transform="translate(16 17.75)"
                  fill="none"
                  stroke="#bf8d46"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  stroke-dasharray="0 0"
                />
              </g>
            </g>
          </g>
        </svg>
      ),
    },
    {
      value: userData?.user ? "logout" : "login",
      icon: (
        <svg
          id="logout"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <g id="vuesax_outline_logout" data-name="vuesax/outline/logout">
            <g id="logout-2" data-name="logout">
              <path
                id="Vector"
                d="M6.962,20.54c-4.44,0-6.58-1.75-6.95-5.67a.751.751,0,0,1,.68-.82.765.765,0,0,1,.82.68c.29,3.14,1.77,4.31,5.46,4.31H7.1c4.07,0,5.51-1.44,5.51-5.51V7.01c0-4.07-1.44-5.51-5.51-5.51h-.13c-3.71,0-5.19,1.19-5.46,4.39A.758.758,0,0,1,0,5.76C.342,1.78,2.492,0,6.962,0h.13C12,0,14.1,2.1,14.1,7.01v6.52c0,4.91-2.1,7.01-7.01,7.01Z"
                transform="translate(8.148 1.73)"
                fill="#bf8d46"
              />
              <path
                id="Vector-2"
                data-name="Vector"
                d="M.75,1.5A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0H12.13a.755.755,0,0,1,.75.75.755.755,0,0,1-.75.75Z"
                transform="translate(2.869 11.25)"
                fill="#bf8d46"
              />
              <path
                id="Vector-3"
                data-name="Vector"
                d="M3.568,7.978.218,4.628a.754.754,0,0,1,0-1.06L3.568.218a.75.75,0,0,1,1.06,1.06L1.807,4.1l2.82,2.82a.754.754,0,0,1,0,1.06.725.725,0,0,1-.53.22A.742.742,0,0,1,3.568,7.978Z"
                transform="translate(1.752 7.903)"
                fill="#bf8d46"
              />
              <path
                id="Vector-4"
                data-name="Vector"
                d="M24,0V24H0V0Z"
                fill="#bf8d46"
                opacity="0"
              />
            </g>
          </g>
        </svg>
      ),
    },
  ];

  const handleTheme = (val: string) => {
    dispatch(toggleTheme(val));
  };

  const handleChangeLanguage = (language: string) => {
    dispatch(setCurrnetLanguage(language));
    changeTranslation(language);
  };

  const layoutDirection = useBreakpointValue({ base: "column", md: "row" });

  return (
    <>
      <TouchableOpacity onClick={onOpen}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25.987"
          height="26"
          viewBox="0 0 25.987 26"
        >
          <g
            id="Group_7263"
            data-name="Group 7263"
            transform="translate(-328 -50)"
          >
            <path
              id="Vector"
              d="M18.447,0H7.553C2.821,0,0,2.821,0,7.553V18.434C0,23.179,2.821,26,7.553,26H18.434c4.732,0,7.553-2.821,7.553-7.553V7.553C26,2.821,23.179,0,18.447,0Z"
              transform="translate(328 50)"
              fill="#ecdfc9"
            />
            <path
              id="Vector-2"
              data-name="Vector"
              d="M13.975,1.95h-13A.982.982,0,0,1,0,.975.982.982,0,0,1,.975,0h13a.982.982,0,0,1,.975.975A.982.982,0,0,1,13.975,1.95Z"
              transform="translate(333.525 56.175)"
              fill="#bf8d46"
            />
            <path
              id="Vector-3"
              data-name="Vector"
              d="M13.975,1.95h-13A.982.982,0,0,1,0,.975.982.982,0,0,1,.975,0h13a.982.982,0,0,1,.975.975A.982.982,0,0,1,13.975,1.95Z"
              transform="translate(333.525 62.025)"
              fill="#bf8d46"
            />
            <path
              id="Vector-4"
              data-name="Vector"
              d="M13.975,1.95h-13A.982.982,0,0,1,0,.975.982.982,0,0,1,.975,0h13a.982.982,0,0,1,.975.975A.982.982,0,0,1,13.975,1.95Z"
              transform="translate(333.525 67.875)"
              fill="#bf8d46"
            />
          </g>
        </svg>
      </TouchableOpacity>

      <Drawer
        placement={"left"}
        onClose={onClose}
        isOpen={isOpen}
        closeOnOverlayClick
      >
        <DrawerOverlay backdropFilter="blur(5px)" />

        <DrawerContent
          bg="secondary.300"
          borderRadius="3xl"
          m={2}
          boxShadow="lg"
          // maxW="450px"
          maxW={layoutDirection === "column" ? "96%" : "450px"}
          pos={"relative"}
        >
          {layoutDirection === "column" && (
            <Button
              variant="outline"
              h={"full"}
              pos={"absolute"}
              top={3}
              right={3}
              onClick={onClose}
              size={["sm", "md"]}
            >
              {"x"}
            </Button>
          )}

          {userData?.user ? (
            <DrawerHeader
              justifyItems={
                layoutDirection === "column" ? "flex-start" : "center"
              }
            >
              <Stack
                align={"center"}
                direction={layoutDirection === "column" ? "row" : "column"}
                // direction={"row"}
              >
                <Image src={profileIcon} h={["50px", "130px"]} />
                <Heading
                  mt={[0, 4]}
                  fontSize={layoutDirection === "column" ? "md" : undefined}
                >
                  {`${userData?.user?.fname} ${userData?.user.lname}`}
                </Heading>
              </Stack>
            </DrawerHeader>
          ) : (
            <Stack h={10} />
          )}

          <DrawerBody p={0} overflowY={"scroll"} className="mac-scrollbar">
            <HStack h={"100%"}>
              <Stack h={"100%"} w={"100%"}>
                <VStack
                  align={isArabic ? "flex-end" : "flex-start"}
                  gap={5}
                  px={6}
                  my={5}
                >
                  {list.map((item, index) => (
                    <TouchableOpacity
                      key={index}
                      flexDirection={"row"}
                      gap={4}
                      onClick={() => {
                        if (item.value === "radio")
                          dispatch(setSelectedSurah({}));
                        if (item?.route) navigation(item?.route);
                        else handleLogout();
                      }}
                    >
                      {isArabic ? (
                        <>
                          <Text color={"primary.300"}>
                            {translation[item.value]}
                          </Text>
                          {item.icon}
                        </>
                      ) : (
                        <>
                          {item.icon}
                          <Text color={"primary.300"}>
                            {translation[item.value]}
                          </Text>
                        </>
                      )}
                    </TouchableOpacity>
                  ))}
                </VStack>

                <Heading
                  px={7}
                  size={"lg"}
                  textAlign={isArabic ? "right" : "left"}
                >
                  {translation["quick_setting"]}
                </Heading>

                <Label title={translation["language"]} />

                <RowBtn
                  list={[
                    { name: "en", title: "english" },
                    { name: "ar", title: "arabic" },
                  ]}
                  selected={isArabic ? "ar" : "en"}
                  onCallback={(val) => handleChangeLanguage(val.name)}
                />

                <Label title={translation["theme"]} />

                <RowBtn
                  list={[
                    { name: "light", title: "light" },
                    { name: "dark", title: "dark" },
                  ]}
                  selected={colorMode}
                  onCallback={(val) => handleTheme(val.name)}
                />
              </Stack>
            </HStack>
          </DrawerBody>

          <DrawerFooter flexDirection={"column"} gap={2}>
            <Link w="full" href="https://alquran.me" isExternal>
              <Button w={"full"}>{translation["al_quran_pro"]}</Button>
            </Link>
            <Button
              variant={"outline"}
              w={"full"}
              onClick={() =>
                (window.location.href = "mailto:info@alquran.network")
              }
            >
              {translation["send_feedback"]}
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default CustomeDrawer;

const Label: React.FC<{ title: string }> = ({ title }) => {
  const { isArabic } = useTranslation();
  return (
    <Stack
      w={"100%"}
      bgColor={"secondary.350"}
      p={2}
      my={2}
      align={isArabic ? "flex-end" : "self-start"}
    >
      <Text color={"primary.300"}>{title}</Text>
    </Stack>
  );
};

const RowBtn: React.FC<{
  list: any[];
  selected: string;
  onCallback: (res: any) => void;
}> = ({ list, selected = false, onCallback }) => {
  const { translation } = useTranslation();

  return (
    <HStack px={7} w={"100%"}>
      {list.map((it, index) => (
        <Button
          key={index}
          w={"100%"}
          h={[10, 12]}
          bgColor={selected === it.name ? undefined : "secondary.350"}
          border={
            selected === it.name
              ? undefined
              : "1px solid var(--chakra-colors-secondary-900)"
          }
          onClick={() => onCallback(it)}
        >
          {translation[it.title]}
        </Button>
      ))}
    </HStack>
  );
};
